<template>
	<div>
    	<slot></slot>
	</div>
</template>

<script>
	import PerfectScrollbar from 'perfect-scrollbar';
	export default {
		mounted() {
			var self = this;
			$(self.$el).find('.wrapper-content').perfectScrollbar();
			  	
			//var ps = new PerfectScrollbar(container);
            $(document).ready(function() {
            	var parent = $(self.$el).outerHeight();
				var header = 0;
				$(self.$el).find('.wrapper-ignore').each(function(){
					header += $(this).outerHeight() ? $(this).outerHeight() : 0;
				});

				var height = (parent ? parent : 0) - (header ? header : 0);

				$(self.$el).find('.wrapper-content').height(height);
				$(self.$el).find('.wrapper-content').perfectScrollbar('update');
			});

			$(window).resize(function() {
				var parent = $(self.$el).outerHeight();
				var header = 0;
				$(self.$el).find('.wrapper-ignore').each(function(){
					header += $(this).outerHeight() ? $(this).outerHeight() : 0;
				});

				var height = (parent ? parent : 0) - (header ? header : 0);

				$(self.$el).find('.wrapper-content').height(height);
				$(self.$el).find('.wrapper-content').perfectScrollbar('update');
			});

			setTimeout(function(){
				if($(self.$el).find('.wrapper-content')){
					$(self.$el).find('.wrapper-content').perfectScrollbar('update');
				}
			}, 3000);
        },

        destroy() {
        	//$(self.$el).perfectScrollbar().destroy();
        }
	}
</script>